import { render } from "./ExploreNewestItem.vue?vue&type=template&id=0f0d652a"
import script from "./ExploreNewestItem.vue?vue&type=script&lang=js"
export * from "./ExploreNewestItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__